import { ref } from 'vue'
import { defineStore } from 'pinia'

export const usePromotionStore = defineStore('promotion', () => {
  const currentPromotion = ref('25summer')

  return { currentPromotion }
})